module.exports = __webpack_public_path__ + "img/Weilin WeChat terminal equipment monitoring software.53360a8c.jpg";